import { render, staticRenderFns } from "./ProcessFBMReportTable.vue?vue&type=template&id=40ecc6da&scoped=true"
import script from "./ProcessFBMReportTable.vue?vue&type=script&lang=js"
export * from "./ProcessFBMReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ecc6da",
  null
  
)

export default component.exports